import React, { useState } from "react";
import Logo from "../../assests/louisville_login_logo.png";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import Input from "../../components/reusable-input/Input";
import { reactIcons } from "../../icons/reactIcons";
import Button from "../../components/reusable-button/Button";
import createApiCall from "../../utils/Api";
import { setAuthToken, setSnackbarDetails } from "../../redux/AuthSlice";
import { useDispatch } from "react-redux";
import loginFormValidation from "../../FormValidations/LoginFormValidations";
import ErrorMessage from "../../components/reusable-errorMessage/ErrorMessage";
import { encryptAES } from "../../utils/encryption";
import { useOktaAuth } from "@okta/okta-react";

interface login {
  setIsAuthenticated: (isAuthenticated: string) => void;
}

interface loginDetails {
  email: string;
  password: string;
}

const Login: React.FC<login> = ({ setIsAuthenticated }) => {
  const { oktaAuth } = useOktaAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [disableLoginBtnStatus, setDisableLoginBtnStatus] = useState(false);
  const [isOktaLoginLoading, setIsOktaLoginLoading] = useState(false);
  const [loginDetails, setLoginDetails] = useState<loginDetails>({
    email: "",
    password: "",
  });

  //using the following state to toggle password visibility
  const [showPassword, setShowPassword] = useState(false);

  //using the following state to render the errorMsgs onSubmit
  const [errMsg, setErrMsg] = useState({
    email: "",
  });

  const handleLoginDetailsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLoginDetails({
      ...loginDetails,
      [e.target.name]: e.target.value,
    });
  };

  const handleOktaSignIn = async () => {
    try {
      setIsOktaLoginLoading(true);
      sessionStorage.setItem("okta_login_pending", "true");
      sessionStorage.removeItem("okta_logout_requested");
      await oktaAuth.signInWithRedirect();
    } catch (err) {
      setIsOktaLoginLoading(false);
      sessionStorage.removeItem("okta_login_pending");
      console.error("Okta sign-in redirect error:", err);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setDisableLoginBtnStatus(true);
    setErrMsg({ email: "" });
    let { status, statusMessage } = loginFormValidation(loginDetails?.email);
    if (status) {
      try {
        const encryptedPayload = {
          email: encryptAES(loginDetails.email),
          password: encryptAES(loginDetails.password),
        };

        const response = await createApiCall().post(
          "/admin/login",
          encryptedPayload,
        );
        if (response?.data) {
          const userDetails = response?.data?.data;
          const accessToken =
            userDetails?.accessToken || userDetails?.accesstoken;

          if (!accessToken) {
            throw new Error("Login response did not return an access token");
          }

          const loginUserDetails = { ...userDetails, accessToken };

          localStorage.setItem("tobacco_access_token", accessToken);
          localStorage.setItem(
            "tobocco_user_name",
            JSON.stringify(loginUserDetails),
          );
          sessionStorage.removeItem("okta_authenticated");
          sessionStorage.removeItem("okta_login_pending");
          sessionStorage.removeItem("okta_logout_requested");

          setDisableLoginBtnStatus(false);
          setIsAuthenticated(accessToken);
          dispatch(setAuthToken(loginUserDetails));
          dispatch(
            setSnackbarDetails({
              type: "success",
              message: `${
                response?.data?.data?.message || "User login succesfull!"
              }`,
            }),
          );
          navigate("/manage-inspector", { replace: true });
        }
      } catch (error: any) {
        setDisableLoginBtnStatus(false);
        setErrMsg({
          email:
            error?.response?.data?.data?.message || "something went wriong!",
        });
        console.log("login:error", error);
      }
    } else {
      setDisableLoginBtnStatus(false);
      setErrMsg({ email: statusMessage });
    }
  };

  console.log("loginDetails:", loginDetails);

  return (
    <div className="login-container">
      <div>
        <div className="login-card">
          <img src={Logo} alt="Department Logo" className="login-logo" />
          <div>
            <h2 className="login-subtitle">Admin Portal</h2>
            <p className="login-description">
              Log in to manage inspectors, admins and reports
            </p>
          </div>
          <form onSubmit={handleSubmit} className="login-form">
            {/* <label htmlFor="email">Email Address *</label> */}
            <Input
              type="text"
              placeholder="Enter Your Email"
              label="Email Address"
              value={loginDetails.email}
              name="email"
              onChange={(e) => handleLoginDetailsChange(e)}
              required
              autoComplete="new-username"
            />

            {/* <label htmlFor="password">Password *</label> */}
            <div className="password-field">
              <Input
                type={showPassword ? "text" : "password"}
                placeholder="Enter Your Password"
                label="Password"
                endIcon={
                  showPassword ? (
                    <reactIcons.visibilityOnIcon />
                  ) : (
                    <reactIcons.visibilityOffIcon />
                  )
                }
                value={loginDetails.password}
                name="password"
                onChange={(e) => handleLoginDetailsChange(e)}
                required
                onClickEndIcon={() => setShowPassword(!showPassword)}
                autoComplete="new-password"
              />
            </div>
            <div className="inspectorList--errMsg">
              {/* {loginDetails.email !== "" && ( */}
              <ErrorMessage message={errMsg?.email} />
              {/* )} */}
            </div>

            <div className="login-btn">
              <Button
                type="submit"
                text="Log In"
                loading={disableLoginBtnStatus}
              />
              <div className="login-divider">or</div>
              <Button
                type="button"
                text="Sign in with Okta"
                onClick={handleOktaSignIn}
                loading={isOktaLoginLoading}
              />
            </div>
          </form>
        </div>
        <p className="login-footer">
          Contact your system administrator if you need access
        </p>
      </div>
    </div>
  );
};

export default Login;
